import React from 'react';
import { PlanningPhaseSelector } from 'alakai-aloha-shared/public-ui/planning-selector';
import { useIslandHeroBackgroundImage } from '../../components/homepage/useIslandHeroBackgroundImage';
import { trackEvent } from '../../utils/analytics';
import { getPlanningPortalNavigationPath } from './planningPhasePortals';
import { getPlanningPhasePortalPath } from './planningPhases';

export default function HomepagePlanningSelector({
  islandKey,
  islandName,
  initialPhaseId = null,
  phases,
  onPhaseChange,
  onExploreResources,
  className = '',
}) {
  const { currentHeroEntry, heroEntries } = useIslandHeroBackgroundImage(islandKey, {
    surface: 'homepage',
    storageNamespace: 'homepage-hero',
  });

  const handlePhaseChange = React.useCallback((phase) => {
    onPhaseChange?.(phase);
    trackEvent(phase ? 'homepage_planning_phase_select' : 'homepage_planning_phase_clear', {
      island_key: islandKey,
      phase_id: phase?.id,
      phase_order: phase?.order,
      source: 'planning_timeline',
    });
  }, [islandKey, onPhaseChange]);

  const handleExploreResources = React.useCallback((phase) => {
    onExploreResources?.(phase);
    trackEvent('homepage_planning_resources_click', {
      island_key: islandKey,
      phase_id: phase.id,
      phase_order: phase.order,
      source: 'planning_timeline',
    });
  }, [islandKey, onExploreResources]);

  const getPhaseHref = React.useCallback((phase) => {
    const path = getPlanningPhasePortalPath(phase.id);
    return path ? getPlanningPortalNavigationPath(path, islandKey) : '/';
  }, [islandKey]);

  return (
    <PlanningPhaseSelector
      islandKey={islandKey}
      islandName={islandName}
      initialPhaseId={initialPhaseId}
      phases={phases}
      surface="homepage"
      headingLevel={1}
      resourceCtaLabel="Explore resources"
      heroEntry={currentHeroEntry}
      heroEntries={heroEntries}
      className={className}
      getPhaseHref={getPhaseHref}
      onPhaseChange={handlePhaseChange}
      onExploreResources={handleExploreResources}
      onImpression={() => trackEvent('planning_selector_impression', {
        island_key: islandKey,
        surface: 'homepage',
      })}
    />
  );
}
